"use client";

import { useState } from "react";
import { useToast } from "../components/context/ToastContext";
import { IClient } from "../interfaces/client";
import { fetchClient, saveUser } from "../services/clientService";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useClient(initialPage: number = 1) {
  const showToast = useToast();
  const queryClient = useQueryClient();

  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(initialPage);

  const ClientQuery = useQuery<
    { items: IClient[]; totalCount: number },
    Error,
    { Client: IClient[]; totalPages: number }
  >({
    queryKey: ["Client", pageNumber, search] as const,
    queryFn: () => fetchClient(pageNumber, search),
    select: (apiResponse: any) => {
      console.log("apiResponse", apiResponse);
      const items =  apiResponse.data.data || [];
      const totalPages = apiResponse.data.totalPages || 1;
      return { Client: items, totalPages };
    },
    //@ts-ignore
    onError: () => {
      showToast("error", "Erro ao buscar clientes.");
    },
  });


  const saveMutation = useMutation({
    mutationFn: (vars: { data: IClient; editando: boolean; userId?: number }) =>
      saveUser(vars.data, vars.editando, vars.userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Client"] });
      showToast("success", "Cliente salvo com sucesso.");
    },
    onError: () => {
      showToast("error", "Erro ao salvar cliente.");
    },
  });

  function handleSave(data: IClient, editando: boolean, userId?: number) {
    saveMutation.mutate({ data, editando, userId });
  }

  return {
    Client: ClientQuery.data?.Client || [],
    totalPages: ClientQuery.data?.totalPages || 1,
    isLoading: ClientQuery.isLoading,

    // estado de salvamento (mutation)
    isSaving: saveMutation.status === "pending",

    search,
    setSearch,
    pageNumber,
    setPageNumber,

    handleSave,

    refetchClient: ClientQuery.refetch,
  };
}
